import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["copyBtn", "copyIcon", "checkIcon", "thumbUp", "thumbDown"]
  static values  = { content: String }

  async copy() {
    try {
      await navigator.clipboard.writeText(this.contentValue)
    } catch (err) {
      console.warn("[message-actions] clipboard failed", err)
      return
    }
    this.copyBtnTarget.classList.add("is-copied")
    this.copyIconTarget.style.display = "none"
    this.checkIconTarget.style.display = ""
    clearTimeout(this._copyTimeout)
    this._copyTimeout = setTimeout(() => {
      this.copyBtnTarget.classList.remove("is-copied")
      this.copyIconTarget.style.display = ""
      this.checkIconTarget.style.display = "none"
    }, 1500)
  }

  thumbUp() {
    this._toggleFeedback(this.thumbUpTarget, this.thumbDownTarget)
  }

  thumbDown() {
    this._toggleFeedback(this.thumbDownTarget, this.thumbUpTarget)
  }

  _toggleFeedback(active, other) {
    const wasActive = active.classList.contains("is-active")
    other.classList.remove("is-active")
    active.classList.toggle("is-active", !wasActive)
  }
}
